import React from 'react'
import { ProgressBarStyles } from './ProgressBarStyles'

interface progressBarProperties {
    width: number
}

export function ProgressBarComponent(properties: progressBarProperties) {
    return (
        <div style={ProgressBarStyles.container}>
            <div style={ProgressBarStyles.content}>
                <div
                    style={{
                        ...ProgressBarStyles.progress,
                        width: `${properties.width}%`,
                    }}
                ></div>
            </div>
        </div>
    )
}
